// 🎯 نسخة الفرونت إند من default_chart_of_accounts_template() في main.py -
// نفس الأكواد الأساسية بالظبط (من غير لاحقة "-{org_id}"). الوصف
// المتخزن في قاعدة البيانات إنجليزي دايمًا (القيمة المرجعية المشتركة)،
// وده بيترجمه لحظة العرض بس حسب لغة المستخدم الحالية - نفس أسلوب أي
// نص تاني في الشاشة، عشان أي لغة غير عربي/إنجليزي (فرنساوي، صيني..
// إلخ) تشتغل صح من غير ما نحتاج نخزن نسخة تانية من الوصف في الداتا
const DEFAULT_ACCOUNT_I18N_KEYS = {
  "1000": "assets",
  "1100": "inventory_assets",
  "1300": "accumulated_depreciation",
  "TAX-INPUT": "tax_input",
  "2000": "liabilities",
  "AP-VENDORS": "ap_vendors",
  "WO-ACCRUED": "wo_accrued",
  "ASSET-ACQUISITION-CLEARING": "asset_acquisition_clearing",
  "4000": "revenue",
  "SLA-PENALTY-INCOME": "sla_penalty_income",
  "5000": "expenses",
  "5100": "cogs",
  "5200": "depreciation_expense",
  "WO-LABOR-EXPENSE": "wo_labor_expense",
  "WO-TOOLS-EXPENSE": "wo_tools_expense",
  "WO-SERVICES-EXPENSE": "wo_services_expense",
};

// account: أي كائن فيه {glaccount, org_id, description} - بيرجع الوصف
// مترجم للغة الحالية لو الحساب من الحسابات الافتراضية المزروعة، وإلا
// بيرجع description الخام زي ما هو (حساب اليوزر عمله يدوي، نص حر)
export function translateAccountDescription(account, t) {
  if (!account) return '';
  const code = account.glaccount || '';
  const orgId = account.org_id;
  const suffix = orgId ? `-${orgId}` : null;
  const baseCode = suffix && code.endsWith(suffix) ? code.slice(0, -suffix.length) : code;
  const i18nKey = DEFAULT_ACCOUNT_I18N_KEYS[baseCode];
  if (i18nKey) {
    return t(`gl.default_accounts.${i18nKey}`, account.description);
  }
  return account.description;
}

export default DEFAULT_ACCOUNT_I18N_KEYS;
